import React, { useState } from "react";

import SectionTitle from "@app/components/3_modules/sections/SectionTitle";
import InputText from "@app/components/2_widgets/inputs/InputText";

import { FilePenLine, ChevronUp, ChevronDown } from "lucide-react";
import { useAuth } from '@app/contexts/AuthContext';
import { apiCall } from '@app/utils/apiCall';
import { buildCustomerFormDataBuilder } from "@app/utils/form_data_builders/CustomerFormDataBuilder";
import { useCustomer } from "@app/contexts/CustomerContext";

import SectionPDL from "@app/components/2_widgets/dossiers/SectionPDL";
import SectionEnedis from "@app/components/2_widgets/dossiers/SectionEnedis";

export default function SectionAuthorisation({ activateSaved }) {
    const [displaying, setDisplaying] = useState(false);

    const auth = useAuth();
    const customer = useCustomer();

    function updateCustomer(key, value) {
        if (customer.id) {
            customer[key] = value;
            
            const formData = buildCustomerFormDataBuilder(customer);
            
            activateSaved(true);

            apiCall({
                method: "patch",
                path: `/api/v1/customers/${customer.id}`,
                auth: auth,
                data: formData,
                onSuccess: (response) => {                
                    // Launch saved animation
                    activateSaved(false);
                }
            });
        }
    }

    function displayContent() {
        if (!displaying)
            return;

        return (
            <div>                
                <div className="row mb-3">
                    <div className="col-md-12 col-lg-6">
                        <InputText 
                            inputId="text-input"
                            label="Prénom du dirigeant"                            
                            placeholder="Francis"
                            defaultValue={customer.first_name}
                            callbackOnChange={(value) => updateCustomer("first_name", value)}
                            callbackBlur={(error, value) => updateCustomer("first_name", value)}
                        />
                    </div>
                    <div className="col-md-12 col-lg-6">
                        <InputText 
                            inputId="text-input"
                            label="Nom du dirigeant"                            
                            placeholder="Martin"
                            defaultValue={customer.last_name}
                            callbackOnChange={(value) => updateCustomer("last_name", value)}
                            callbackBlur={(error, value) => updateCustomer("last_name", value)}
                        />
                    </div>
                </div>
                <SectionPDL activateSaved={activateSaved} />
                <SectionEnedis />
            </div>
        )
    }

    return (
        <div className="page-section">
            <SectionTitle
                icon={<FilePenLine />}
                title="Autorisations et Mandat"
                onClick={() => setDisplaying(!displaying)}
                rightIcon={displaying ? <ChevronUp /> : <ChevronDown />}
            />
            {displayContent()}
        </div>
    )
}